import { render } from "./CustomerSatisfaction.vue?vue&type=template&id=2f32fb77&ts=true"
import script from "./CustomerSatisfaction.vue?vue&type=script&lang=ts"
export * from "./CustomerSatisfaction.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__